import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    paddingRight: 7,
  },
  separator: {
    paddingVertical: 10,
  },
  rootDescription: {
    paddingBottom: 10,
  },
});
